var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 486,
    viewBox: "0 0 146 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.045 218.864C118.282 262.971 109.47 325.671 65.363 358.909C65.363 358.909 38.4188 323.152 5.18153 279.045C-28.0558 234.938 -55 199.181 -55 199.181C-10.8926 165.944 51.8077 174.756 85.045 218.864Z",
    fill: "#4285F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -322.25,
    y: 0.75,
    width: 366.5,
    height: 383.5,
    rx: 74.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -232.25,
    y: 101.75,
    width: 366.5,
    height: 383.5,
    rx: 74.25,
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeftBg);
export default __webpack_public_path__ + "static/media/top-left-bg.906e5b6bb81baa6a39d1b4610885b6aa.svg";
export { ForwardRef as ReactComponent };